module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/sport_alliance_magicline_awarenessfilm.jpg";